import React from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';

/**
 * Component for selecting a building
 * @param {Object} props - Component props
 * @param {string} props.selectedBuilding - Currently selected building ID
 * @param {Function} props.handleBuildingChange - Handler for building selection change
 * @param {boolean} props.disabled - Whether the selector is disabled
 * @param {Array} props.buildings - List of available buildings
 */
const BuildingSelector = ({ selectedBuilding, handleBuildingChange, disabled, buildings = [] }) => {
  return (
    <FormControl className="building-select" disabled={disabled}>
      <Select
        value={selectedBuilding}
        onChange={handleBuildingChange}
        displayEmpty
        className="select-box"
        // renderValue={(selected) => {
        //   if (selected === "") {
        //     return <em>Select Building</em>;
        //   }
        //   const building = buildings.find(b => b.id === selected);
        //   return building ? building.name : selected;
        // }}
      >
        <MenuItem value="" disabled>
          <em>Select Building</em>
        </MenuItem>
        {buildings.map((building) => (
          <MenuItem key={building.building_id} value={building.building_id}>
            {building.address}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BuildingSelector; 